var map = {
	"./ADA.svg": 924,
	"./BCH.svg": 925,
	"./BNB.svg": 926,
	"./BTC.svg": 927,
	"./CHZ.svg": 928,
	"./DASH.svg": 929,
	"./DOGE.svg": 930,
	"./DOT.svg": 931,
	"./ETC.svg": 932,
	"./ETH.svg": 933,
	"./EUR.svg": 934,
	"./GBP.svg": 935,
	"./LINK.svg": 936,
	"./LTC.svg": 937,
	"./MATIC.svg": 938,
	"./MKR.svg": 939,
	"./SHIB.svg": 940,
	"./SOL.svg": 941,
	"./TRX.svg": 942,
	"./UNI.svg": 943,
	"./USD.svg": 944,
	"./USDT.svg": 945,
	"./XLM.svg": 946,
	"./XMR.svg": 947,
	"./XRP.svg": 948,
	"./documents.svg": 949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 923;